import React, { useRef, useEffect } from "react"
import { useThree } from "react-three-fiber"
import AnimatedText from "../_helpers/AnimatedText"
import { useSpring, a, config } from "react-spring/three"

function Title({
  color,
  content,
  outlineColor,
  roughness,
  layers,
  desktopRightHovered,
  desktopRightClicked,
  desktopLeftClicked,
  mobileRightClicked,
  mobileLeftClicked,
  ...props
}) {
  const group = useRef()
  const { viewport } = useThree()

  const isIOS = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  let fontSize = viewport.width * 0.1

  if (isIOS) {
    fontSize = viewport.width * 0.15
  }

  const aprops = useSpring({
    // Phone

    color: desktopRightClicked || desktopRightHovered ? "#ffffff" : mobileRightClicked ? "#ffffff" : "#1d1d1d",
    position: desktopLeftClicked
      ? [0, 3.5, 0]
      : desktopRightClicked
      ? [0, 1.5, 0]
      : mobileLeftClicked
      ? [1.5, 0, 0]
      : mobileRightClicked
      ? [0, -0.2, 0]
      : [0, 0, 0],

    // General Config
    config: {
      tension: 16,
      friction: 8,
    },
  })

  useEffect(() => {
    group.current.lookAt(0, 0, 90)
  }, [])

  return (
    <group {...props} ref={group}>
      <AnimatedText
        name="N"
        fontSize={fontSize}
        color={aprops.color}
        maxWidth="1"
        font="fonts/NewYork.woff"
        outlineWidth={0.005}
        outlineColor={aprops.color}
        position={aprops.position}>
        {content}
      </AnimatedText>
    </group>
  )
}
// <meshPhysicalMaterial metalness={1} roughness={1.5} color={color}  />

export default Title
